var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"round-checkbox",class:{ left: _vm.textLeft }},[_c('label',{staticClass:"switch"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"click":_vm.emitClick}}),_c('span',{staticClass:"slider round"})]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }